import React from 'react';
import { connect } from 'react-redux';
import { bool, number, string } from 'prop-types';
import EmailLoginContainer from '../views/reactViews/EmailLoginContainer';
import EmailLoginContainer_Deprecated from '../views/reactViews/EmailLoginContainer_Deprecated';
import { getRedirectUrl } from '../selectors/EmailLoginSelectors';
import FeatureToggleUtils from 'FeatureToggleUtils';
import BootstrapData from 'models/BootstrapData';
import { getAccessToken } from '../AuthToken';
import {
    eventGroupIdSelector,
    eventIdSelector,
    eventWelcomeMessagesSelector,
    getPublicWebsiteBaseUrlSelector,
    websiteTypeSelector,
    whitelabelPathSelector,
    whitelabelUrlSelector,
    whitelabelWidgetEnabledSelector,
    onlyEventDomainSelector
} from '../selectors/EventSelectors';
import {
    enableTicketIdLoginSelector,
} from '../selectors/LoginSelectors';

export const getIsAuthenticated = (state) => !!getAccessToken();

const isWebLoginUsed = () => !FeatureToggleUtils.isFeatureEnabled('oldLogin');

const isWidget = BootstrapData('bootstrap-data-isWidgetObject').isWidget;

const loginGateway = (TargetComponent) => (props) =>
    props.isAuthenticated ? (
        <TargetComponent {...props} />
    ) : isWebLoginUsed() ? (
        <EmailLoginContainer {...props} isWidget={isWidget} />
    ) : (
        <EmailLoginContainer_Deprecated {...props} />
    );
loginGateway.propTypes = {
    isAuthenticated: bool,
    eventId: number,
    eventGroupId: number,
    enableTicketIdLogin: bool,
    redirectUrl: string,
};

const withEmailLogin = (TargetComponent) =>
    connect((state) => ({
        isAuthenticated: getIsAuthenticated(state),
        eventId: eventIdSelector(state),
        eventGroupId: eventGroupIdSelector(state),
        enableTicketIdLogin: enableTicketIdLoginSelector(state),
        publicWebsiteBaseUrl: getPublicWebsiteBaseUrlSelector(state),
        redirectUrl: getRedirectUrl(),
        welcomeMessage: eventWelcomeMessagesSelector(state),
        websiteType: websiteTypeSelector(state),
        whitelabelPath: whitelabelPathSelector(state),
        whitelabelUrl: whitelabelUrlSelector(state),
        whitelabelWidgetEnabled: whitelabelWidgetEnabledSelector(state),
        onlyEventDomainSelector: onlyEventDomainSelector(state)
    }))(loginGateway(TargetComponent));



export default withEmailLogin;
